import styled from 'styled-components'

export const FormContent = styled.div`
  max-width: 1120px;
  margin-inline: auto;
  color: #263957;

  .ant-form-item { margin-bottom: 20px; }
  .ant-form-item-label { padding-bottom: 7px; }
  .ant-form-item-label > label { color: #263957; font-size: 12px; font-weight: 650; }
  .ant-input, .ant-input-affix-wrapper {
    min-height: 42px;
    border-color: #ced9e8;
    border-radius: 8px;
    color: #142849;
    font-size: 14px;
  }
  .ant-input::placeholder { color: #8795a9; }
  .ant-input:hover:not(:disabled) { border-color: #9fc4ef; }
  .ant-input:focus { border-color: #0e5fc7; box-shadow: 0 0 0 3px rgba(14, 95, 199, 0.12); }
  .ant-input-status-error:not(.ant-input-disabled) { border-color: #ff4d4f; }
  .ant-select, .ant-picker, .ant-input-number { width: 100%; min-height: 42px; border-radius: 8px; font-size: 14px; }
  .ant-select-single { height: 42px; }
  .ant-select-multiple { height: auto; }
  .ant-picker, .ant-input-number { border-color: #ced9e8; }
  .ant-input-number-input { height: 40px; }
  .ant-btn {
    min-height: 40px;
    height: auto;
    border-radius: 8px;
    border-color: #d8e2ef;
    color: #314764;
    font-size: 13px;
    font-weight: 650;
    box-shadow: none;
  }
  .ant-btn-primary:not(:disabled) { border-color: #0e4ea7; background: #0e4ea7; color: #fff; }
  .ant-btn-primary:hover:not(:disabled) { border-color: #0a3f89; background: #0a3f89; }
  .ant-btn-link { min-height: 32px; border: 0; color: #0f5fc6; padding-inline: 4px; }
  .ant-btn:focus-visible { outline: 2px solid #0f5fc6; outline-offset: 2px; }
  .ant-btn:disabled { color: #9aa7b8; background: #f6f8fb; }
  .ant-descriptions { margin-bottom: 0; }
  .ant-descriptions-item-label { color: #708099; font-size: 12px; }
  .ant-descriptions-item-content { color: #263957; font-size: 13px; text-align: left; overflow-wrap: anywhere; }
  .ant-descriptions-item { padding-bottom: 10px; }
  .ant-alert { border-radius: 10px; font-size: 13px; }
  .ant-collapse { border-color: #dfe6f0; border-radius: 12px; background: #f8fafc; }
  .ant-collapse-header { color: #17345f !important; font-size: 13px; font-weight: 650; }
  .ant-collapse-content { border-color: #edf1f6; background: #fff; }
  @media (max-width: 640px) {
    .ant-input { min-height: 44px; font-size: 16px; }
    .ant-select, .ant-picker, .ant-input-number { min-height: 44px; font-size: 16px; }
    .ant-select-single { height: 44px; }
    .ant-picker-input > input, .ant-input-number-input { font-size: 16px; }
    .ant-btn:not(.ant-btn-link) { min-height: 44px; }
  }
`

export const FormHeader = styled.header`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 18px;
  @media (max-width: 760px) { gap: 12px; margin-bottom: 16px; }
`

export const FormTitle = styled.h2`
  margin: 0;
  font-family: var(--font-montserrat);
  font-size: clamp(20px, 2.1vw, 28px);
  font-weight: 750;
  letter-spacing: -0.03em;
  color: #102449;
  @media (max-width: 760px) { display: none; }
`

export const FormDescription = styled.p`
  margin: 6px 0 0;
  max-width: 65ch;
  font-size: 13px;
  line-height: 1.55;
  color: #65748c;
`

export const StepOverview = styled.section`
  overflow: hidden;
  background: #fff;
  border: 1px solid #dfe6f0;
  border-radius: 12px;
  margin-bottom: 18px;
  box-shadow: 0 7px 20px rgba(25, 58, 105, 0.045);
`

export const StepOverviewHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  border-bottom: 1px solid #edf1f6;
  strong { color: #52647f; font-size: 11px; font-weight: 750; letter-spacing: 0.06em; text-transform: uppercase; }
  > span { color: #708099; font-size: 12px; font-variant-numeric: tabular-nums; white-space: nowrap; }
  @media (max-width: 760px) { padding: 12px 14px; }
`

export const StepsViewport = styled.div`
  padding: 16px 20px;
  .ant-steps-item-title { color: #52647f; font-size: 12px; font-weight: 650; }
  .ant-steps-item-process .ant-steps-item-title { color: #0e4ea7; }
  .ant-steps-item-icon { background: #edf2f8; border-radius: 8px; }
  .ant-steps-item-process .ant-steps-item-icon { background: #0e4ea7; }
  @media (max-width: 760px) { display: none; }
`

export const MobileProgress = styled.div<{ $step: number, $count?: number }>`
  display: none;
  @media (max-width: 760px) {
    display: grid;
    grid-template-columns: repeat(${({ $count }) => $count ?? 4}, minmax(0, 1fr));
    gap: 5px;
    padding: 0 14px 12px;
    span { height: 3px; border-radius: 3px; background: #e7edf5; }
    span:nth-child(-n + ${({ $step }) => $step + 1}) { background: #0e5fc7; }
  }
`

export const FormLayout = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 280px;
  align-items: start;
  gap: 18px;
  @media (max-width: 900px) { grid-template-columns: minmax(0, 1fr); }
`

export const FormPanel = styled.section`
  min-width: 0;
  padding: 22px;
  border: 1px solid #dfe6f0;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 7px 20px rgba(25, 58, 105, 0.055);
  @media (max-width: 640px) { padding: 16px; }
`

export const SectionHeader = styled.header`
  display: flex;
  align-items: flex-start;
  gap: 13px;
  margin-bottom: 22px;
  > div { min-width: 0; }
  @media (max-width: 640px) { gap: 10px; margin-bottom: 18px; }
`

export const SectionIcon = styled.span`
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  color: #fff;
  background: linear-gradient(135deg, #08469b, #0d62cc);
  box-shadow: 0 6px 14px rgba(18, 71, 144, 0.16);
  font-size: 18px;
  @media (max-width: 640px) { width: 34px; height: 34px; border-radius: 9px; font-size: 16px; }
`

export const SectionTitle = styled.h3`
  margin: 0;
  font-family: var(--font-montserrat);
  font-size: 20px;
  line-height: 1.3;
  font-weight: 750;
  letter-spacing: -0.025em;
  color: #102449;
  @media (max-width: 640px) { font-size: 18px; }
`

export const SectionDescription = styled.p`
  margin: 6px 0 0;
  font-size: 13px;
  line-height: 1.55;
  color: #65748c;
  max-width: 65ch;
`

export const FieldsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0 16px;
  > * { min-width: 0; }
  @media (max-width: 640px) { grid-template-columns: minmax(0, 1fr); }
`

export const FullField = styled.div`grid-column: 1 / -1;`

export const CityStateRow = styled.div`
  display: grid;
  grid-column: 1 / -1;
  grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
  gap: 16px;
  > * { min-width: 0; }
`

export const Hint = styled.p`
  margin: 10px 0 0;
  font-size: 12px;
  line-height: 1.55;
  color: #708099;
`

export const Feedback = styled.div`
  margin: 16px 0;
  .ant-alert { align-items: flex-start; }
`

export const Eyebrow = styled.span`
  display: block;
  margin-bottom: 8px;
  font-size: 10px;
  font-weight: 750;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: #708099;
`

export const ResultTitle = styled.h3`
  margin: 0 0 14px;
  color: #17345f;
  font-size: 15px;
  font-weight: 750;
  line-height: 1.4;
  overflow-wrap: anywhere;
`

export const ReviewSection = styled.section`
  padding: 14px;
  margin-bottom: 12px;
  border: 1px solid #dfe6f0;
  border-radius: 12px;
  background: #fff;
`

export const ReviewHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid #edf1f6;
  strong { display: flex; align-items: center; gap: 8px; color: #17345f; font-size: 13px; font-weight: 700; }
  strong .anticon { color: #0f5fc6; font-size: 16px; }
`

export const StepActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-top: 18px;
  margin-top: 22px;
  border-top: 1px solid #e8edf4;
  > .ant-btn { margin-left: auto; }
  @media (max-width: 640px) {
    flex-wrap: wrap;
    .ant-btn { min-height: 44px; height: auto; white-space: normal; }
    > .ant-btn { flex: 1; }
    > div:empty { display: none; }
  }
`

export const SummaryPanel = styled.aside`
  min-width: 0;
  border: 1px solid #d8e4f2;
  border-radius: 12px;
  padding: 20px;
  background: radial-gradient(circle at 92% 14%, rgba(77, 137, 213, 0.1), transparent 12rem), #f5f8fc;
  .ant-descriptions-row > td { padding-bottom: 14px; }
  .ant-descriptions-item-label { font-size: 11px; font-weight: 600; }
  .ant-descriptions-item-content { font-size: 12px; }
  > h3 { font-family: var(--font-montserrat); font-size: 18px; letter-spacing: -0.025em; line-height: 1.4; margin-bottom: 20px; }
  @media (max-width: 900px) {
    display: none;
  }
`

export const SummaryHeading = styled.div`
  display: flex;
  align-items: center;
  gap: 9px;
  margin-bottom: 16px;
  > .anticon { color: #0f5fc6; background: #e5effb; padding: 9px; border-radius: 9px; font-size: 17px; }
  > span:last-child { margin-bottom: 0; }
`

export const SummaryFoot = styled.p`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: 12px 0 0;
  padding-top: 14px;
  border-top: 1px solid #dce5f1;
  color: #708099;
  font-size: 12px;
  line-height: 1.55;
  .anticon { flex-shrink: 0; color: #0f5fc6; margin-top: 3px; }
`
